import { 
  PROFILE_ERROR, 
  PROFILE_SUCCESS, 
  EDIT_PROFILE, 
  RESET_PROFILE_FLAG,
  GET_USER_PROFILE_INFO,
  GET_USER_PROFILE_INFO_SUCCESS,
  GET_USER_PROFILE_INFO_FAIL,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAIL
} from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

// New user profile actions
export const getUserProfileInfo = (options) => ({
  type: GET_USER_PROFILE_INFO,
  payload: options
})

export const getUserProfileInfoSuccess = (userProfile) => ({
  type: GET_USER_PROFILE_INFO_SUCCESS,
  payload: userProfile
})

export const getUserProfileInfoFail = (error) => ({
  type: GET_USER_PROFILE_INFO_FAIL,
  payload: error
})

export const updateUserProfile = (data, options) => ({
  type: UPDATE_USER_PROFILE,
  payload: { data, options }
})

export const updateUserProfileSuccess = (message) => ({
  type: UPDATE_USER_PROFILE_SUCCESS,
  payload: message
})

export const updateUserProfileFail = (error) => ({
  type: UPDATE_USER_PROFILE_FAIL,
  payload: error
})
